
export function navigateToContent() {
    let isButtonShown = false;

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Tab' && !isButtonShown) {
        const navToContentBtn = document.getElementById('navigate-to-content');
        if (navToContentBtn) {
          isButtonShown = true;
          navToContentBtn.style.display = 'block';
        }
      }
    });
  
    const navToContentBtn = document.getElementById('navigate-to-content');
    if (navToContentBtn) {
      navToContentBtn.addEventListener('click', function(event) {
        event.preventDefault();
  
        const entryContent = document.querySelector('.entry-content');
        if (entryContent) {
          entryContent.scrollIntoView({
            behavior: 'smooth',
          });
  
          entryContent.setAttribute('tabindex', '-1');
          entryContent.focus();
  
          navToContentBtn.style.display = 'none';
          isButtonShown = true;
        }
      });
    }
  }
  
